import emailjs from '@emailjs/browser';

// EmailJS Configuration
const EMAILJS_CONFIG = {
  serviceId: 'service_auxk8pi',
  templateId: 'template_jfhpjrj',
  publicKey: 'b63bRshngeiy3jcqI'
};

export const sendEmail = async (formData, formType = 'General Contact') => {
  try {
    const templateParams = {
      form_type: formType,
      from_name: formData.name,
      from_email: formData.email,
      company: formData.company || 'Not specified',
      phone: formData.phone || 'Not provided',
      message: formData.message,
      to_email: 'admin@infynihub.com'
    };

    await emailjs.send(
      EMAILJS_CONFIG.serviceId,
      EMAILJS_CONFIG.templateId,
      templateParams,
      EMAILJS_CONFIG.publicKey
    );

    return { success: true };
  } catch (error) {
    console.error('Email send failed:', error);
    return { success: false, error: error.message };
  }
};